const validate = (contact) => {

    let isOk = false
    let resultMessage = ""

    if (!contact) {
        resultMessage = "Presupuesto vacío"
        return ({ isOk, resultMessage })
    }

    if (!contact.name) {
        resultMessage = "Por favor, introduzca el nombre"
        return ({ isOk, resultMessage })
    }

    if (!contact.surname) {
        resultMessage = "Por favor, introduzca los apellidos"
        return ({ isOk, resultMessage })
    }

    if (!contact.institution) {
        resultMessage = "Por favor, introduzca la institución"
        return ({ isOk, resultMessage })
    }

    if (!contact.email && !contact.phone) {
        resultMessage = "Por favor, introduzca email o teléfono de contacto"
        return ({ isOk, resultMessage })
    }

    if (contact.email && !is_real_email(contact.email)) {
        resultMessage = "Formato de email incorrecto"
        return ({ isOk, resultMessage })
    }

    if (contact.phone && !is_real_phone(contact.phone)) {
        resultMessage = "Formato de teléfono incorrecto"
        return ({ isOk, resultMessage })
    }

    if (!contact.message) {
        resultMessage = "Por favor, introduzca el mensaje"
        return ({ isOk, resultMessage })
    }

    if (!contact.accepted) {
        resultMessage = "Por favor, acepte la política de privacidad"
        return ({ isOk, resultMessage })
    }

    isOk = true

    return ({ isOk, resultMessage })

}

// Validador de teléfono

function is_real_phone(telefono) {

    if (!telefono) return false
    const validador = new RegExp("^(\\+34|0034|34)?[6789]\\d{8}$");
    return validador.test(telefono)

}


// Validador de Email 

function is_real_email(email) {

    if (!email) return false
    const validador = new RegExp('^[^@]+@[^@]+\\.[a-zA-Z]{2,}$');
    return validador.test(email)

}

module.exports = {
    validate
}